import React from "react";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { Box, Text } from "@chakra-ui/react";
import { useLocation } from "react-router-dom";

const DocumentsViewer: React.FC = () => {
  const location = useLocation();
  const [fileData, setFileData] = React.useState<{
    fileUrl: string;
    fileType: string;
  } | null>(null);
  const [isLoading, setIsLoading] = React.useState(true);
  const [error, setError] = React.useState<string | null>(null);

  console.log("fileData", fileData);

  React.useEffect(() => {
    setIsLoading(true);
    setError(null);

    const storedData = localStorage.getItem("docViewerData");
    if (storedData) {
      try {
        const parsedData = JSON.parse(storedData);
        setFileData(parsedData);
        // Clear localStorage after reading
        localStorage.removeItem("docViewerData");
        setIsLoading(false);
      } catch (error) {
        console.error("Error parsing stored file data:", error);
        setError("Failed to load file data");
        setIsLoading(false);
      }
    } else {
      setError("No file data found");
      setIsLoading(false);
    }
  }, []);

  if (isLoading) {
    return (
      <Box
        height={"100%"}
        width={"100%"}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Text>Loading document...</Text>
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        height={"100%"}
        width={"100%"}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Text color="red.500">{error}</Text>
      </Box>
    );
  }

  if (!fileData) {
    return (
      <Box
        height={"100%"}
        width={"100%"}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Text>No file to display</Text>
      </Box>
    );
  }

  return (
    <Box height={"100%"} width={"100%"} display="flex" flexDirection="column">
      {/* Document viewer */}
      <Box flex={1}>
        <DocViewer
          documents={[{ uri: fileData.fileUrl, fileType: fileData.fileType }]}
          pluginRenderers={DocViewerRenderers}
          style={{ height: "100%" }}
          className="primary-react-doc-viewer"
        />
      </Box>
    </Box>
  );
};

export default DocumentsViewer;
